import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

import { css } from '@emotion/react';

import Button from '@components/Common/Button';
import CommonModal from '@components/Modals/CommonModal';

import { palette } from '@styles/theme';

interface Props {
  open: boolean;
  handleOpen: () => void;
}

/** 메인 컴포넌트: 임시계정 로그인 알림 모달 */
const TemporaryModal: FunctionComponent<Props> = ({ open, handleOpen }) => {
  return (
    <>
      <CommonModal
        open={open}
        handleOpen={handleOpen}
        title="임시계정 로그인"
        width={400}
        isOutsideClick={false}
      >
        <div css={contentWrap}>
          비밀번호 변경 후 이용해주세요.
          <div className="btnWrap">
            <Link to="/mypage/password-change">
              <Button label="비밀번호 변경하기" width={150} height={40} />
            </Link>
          </div>
        </div>
      </CommonModal>
    </>
  );
};

export default TemporaryModal;

const contentWrap = css`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  .btnWrap {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-end;

    button {
      background-color: ${palette.secondaryColor};
      &:hover,
      &:active {
        background-color: ${palette.secondaryColor};
        opacity: 0.8;
      }
    }
  }
`;
